export const DAMAGE_LEVEL = [
  {
    value: 'NONE',
    color: 'default',
    text: 'general.none'
  },
  {
    value: 'SOFT',
    color: 'info',
    text: 'monitoring.low'
  },
  {
    value: 'MODERATE',
    color: 'warning',
    text: 'monitoring.warning'
  },
  {
    value: 'HARD',
    color: 'error',
    text: 'monitoring.high'
  }
]

export const getFileErrorMessages = (error, showNotification) => {
  const fr = new FileReader()
  fr.onload = (e) => {
    showNotification(JSON.parse(e.target.result).message, 'error', -1)
  }
  fr.readAsText(error)
}